import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/filterForm/resourcesFilter/styles.scss';export default {
  "resourcesFilter": "_resourcesFilter_bdnfl_1",
  "input": "_input_bdnfl_7",
  "toggleArrow": "_toggleArrow_bdnfl_23",
  "selectedResourcesNames": "_selectedResourcesNames_bdnfl_31",
  "list": "_list_bdnfl_40",
  "item": "_item_bdnfl_54",
  "opened": "_opened_bdnfl_62"
};